import React from 'react';
import { Button } from 'react-bootstrap';

interface LottoMenuEntryProps {
  onOpen: () => void;
}

const LottoMenuEntry: React.FC<LottoMenuEntryProps> = ({ onOpen }) => (
  <section className="mobile-drawer-section lotto-menu-section">
    <h5 className="sidebar-header">Lotto 6/45</h5>
    <Button variant="warning" onClick={onOpen}>
      <i className="bi bi-stars me-2" aria-hidden="true" />로또 번호 추첨하기
    </Button>
  </section>
);

export default LottoMenuEntry;
